/**
 * Returns the difference between initially set date which is Jul 1 2018 = 1530428400000
 * and returns the updated date object based on current date;
 * @param {Number} currentDate current date
 * @param {Number} prevDate previous date
 */

export function getSchoolYear() {
  const date = new Date(Date.now())

  if (date.getMonth() > 6) {
    return {
      year: `${date.getFullYear()}`,
      timeStamp: date.getTime(),
      date: `${date.toDateString() + "-" + Number(date.getFullYear())}`
    }
  } else {
    return {
      year: `${date.getFullYear() - 1}`,
      timeStamp: date.getTime(),
      date: `${date.toDateString() + "-" + Number(date.getFullYear() - 1)}`
    }
  }
}

/**
 * determines which school year a date belongs to.
 * @param {Number} date takes in a timestamp.
 * @returns {string} school year eg.. sy2xxx
 */
export function determineSchoolYear(date) {
  let createdDate = new Date(date)

  if (createdDate.getMonth() > 6) {
    return `${createdDate.getFullYear()}`
  } else {
    return `${createdDate.getFullYear() - 1}`
  }
}
